export const PERMISSIONS = [
  { key: "dashboard", label: "Πίνακας" },
  { key: "analytics", label: "Αναλύσεις & Στατιστικά" },
  { key: "inventory", label: "Στόλος" },
  { key: "add_car", label: "Νέο / Επεξεργασία Αυτοκινήτου" },
  { key: "import_cargr", label: "Εισαγωγή car.gr" },
  { key: "sell_leads", label: "Αιτήσεις Πώλησης" },
  { key: "trash", label: "Διαγραμμένα" },
  { key: "exports", label: "Εξαγωγές" },
  { key: "settings", label: "Ρυθμίσεις" },
];

export const ROLE_DEFAULTS = {
  admin: PERMISSIONS.map((p) => p.key).concat(["users"]),
  partner: ["dashboard", "analytics", "inventory", "add_car", "import_cargr", "sell_leads", "trash", "exports"],
  salesperson: ["inventory", "add_car"],
};

export function userPerms(user) {
  if (!user) return [];
  if (user.role === "admin") return ROLE_DEFAULTS.admin;
  if (Array.isArray(user.permissions) && user.permissions.length) return user.permissions;
  return ROLE_DEFAULTS[user.role] || [];
}
